import { action$, extractPayload, ofType, withNamespace } from '@ardoq/rxbeach';
import { setFilterTerm } from '../actions/navigatorActions';
import { identity } from 'lodash';
import { debounceTime } from 'rxjs';

export const getFilterTermStream = (namespace?: string) =>
  action$.pipe(
    namespace ? withNamespace(namespace) : identity,
    ofType(setFilterTerm),
    extractPayload(),
    debounceTime(16)
  );
